/**
 * Сообщение из одних эмодзи — рисуется крупно и без пузыря, как в Telegram.
 *
 * Графемы считаются через `Intl.Segmenter`: флаг — пара региональных
 * индикаторов, семья или тон кожи — одна графема с ZWJ и модификаторами.
 * Без сегментатора (старые движки) счёт по code point — тогда составные
 * эмодзи просто не попадут под правило, что безопасно.
 */
const GRAPHEMES =
  typeof Intl !== 'undefined' && 'Segmenter' in Intl
    ? new Intl.Segmenter(undefined, { granularity: 'grapheme' })
    : null

/** Больше трёх эмодзи крупно уже не читается. */
export const EMOJI_ONLY_MAX = 3

/** Сколько эмодзи в сообщении, если оно состоит только из них (1–3), иначе 0. */
export function emojiOnlyCount(text: string | null | undefined): number {
  const trimmed = text?.trim() ?? ''
  if (!trimmed || trimmed.length > 24) return 0

  const graphemes = GRAPHEMES ? [...GRAPHEMES.segment(trimmed)].map((part) => part.segment) : [...trimmed]
  if (graphemes.length > EMOJI_ONLY_MAX) return 0

  const isEmoji = (grapheme: string) =>
    /^\p{Extended_Pictographic}/u.test(grapheme) || /^\p{Regional_Indicator}{2}$/u.test(grapheme)
  return graphemes.every(isEmoji) ? graphemes.length : 0
}
